<section class="breadcrumb-section">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="breadcrumb-title">
                    <h1> Events</h1>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-lg std-scholarship">
    <div class="container">
        <!-- <div class="events-inner">
            <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/sada-gyan-series-2.webp"
                alt="EVENTS | GHRCACSN">
            <h4>Sada Gyan Series</h4>
            <p>GHRCACS, Nagpur hosted the SADA GYAN Series featuring Lt General Ajai Kumar Singh, whose address offered
                valuable perspectives on leadership, discipline, and national service.</p>

            <a class="cmn-button" routerLink="/sada-gyan-series">
                Read More <i class="fa fa-long-arrow-right"></i></a>
        </div> -->
        <div class="events-inner">
            <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/installation-ceremony-2.webp"
                alt="EVENTS | GHRCACSN">
            <h4>Installation Ceremony</h4>
            <p>The Installation Ceremony at GHRSTU, Nagpur and GHRCACS, Nagpur symbolised fresh responsibilities, shared
                vision, and a commitment to collective growth.</p>

            <a class="cmn-button" routerLink="/installation-ceremony">
                Read More <i class="fa fa-long-arrow-right"></i></a>
        </div>
        <div class="events-inner">
            <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/toastmaster- fest-2.webp"
                alt="EVENTS | GHRCACSN">
            <h4>Toast fest, a major event of Toastmasters </h4>
            <p>Toast Fest at GHRCACS, Nagpur brought together voices, ideas, and confidence, marking a key Toastmasters
                event focused on growth and leadership.</p>

            <a class="cmn-button" routerLink="/toastmasters">
                Read More <i class="fa fa-long-arrow-right"></i></a>
        </div>
        <div class="events-inner">
            <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/pickleball-1.webp"
                alt="EVENTS | GHRCACSN">
            <h4>Pickleball Inauguration </h4>
            <p>GHRCACS, Nagpur came together with dignitaries, faculty, and students for the Pickleball inauguration —
                marking the start of a fresh sporting chapter.</p>
            <a class="cmn-button" routerLink="/pickleball-inauguration">
                Read More <i class="fa fa-long-arrow-right"></i></a>
        </div>
        <div class="events-inner">
            <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/miss-nation-1.webp"
                alt="EVENTS | GHRCACSN">
            <h4>Miss Nation Competition </h4>
            <p>Grace, grit, and glamour lit up the stage at GHRCACS, Nagpur during the Miss Nation Competition.</p>
            <a class="cmn-button" href="/miss-nation-competition">
                Read More <i class="fa fa-long-arrow-right"></i></a>
        </div>
        <!-- <div class="events-inner">
            <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/toaster-1.webp"
                alt="EVENTS | GHRCACSN">
            <h4>Toastmasters Event</h4>
        </div> -->
        <div class="events-inner">
            <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/engfinity-club-1.webp"
                alt="EVENTS | GHRCACSN">
            <h4>Engfinity Club' s Mega Event </h4>
            <p>Engfinity Club’s Mega Event at GHRCACS, Nagpur was a spectacular blend of innovation, teamwork, and
                creativity. Students showcased remarkable talent through engaging activities, inspiring sessions, and
                collaborative challenges, making it a truly memorable and enriching experience for all.</p>
            <a class="cmn-button" href="/engfinity2025">
                Read More <i class="fa fa-long-arrow-right"></i></a>
        </div>
        <div class="events-inner">
            <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/farewell-party-3.webp"
                alt="EVENTS | GHRCACSN">
            <h4>Farewell Party -2025 </h4>
            <p>GHRCACS, Nagpur hosted Farewell Party 2025, celebrating the journey of outgoing students with joy,
                nostalgia, and warm wishes for the road ahead.
                #Farewell2025 #GHRCACS #NewBeginnings #CherishedMoments</p>
            <p>GHRCACS, Nagpur hosted a heartfelt Farewell Ceremony, celebrating the journey of outgoing students with
                joy, reflection, and best wishes for their next big chapter. </p>
            <a class="cmn-button" href="/farewell-party-twentyfive">
                Read More <i class="fa fa-long-arrow-right"></i></a>
            <!-- <a class="cmn-button" href="farewell-party-twetyfive">
                Read More <i class="fa fa-long-arrow-right"></i></a> -->
        </div>

        <!-- <div class="events-inner">
            <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/finfest-1.webp"
                alt="EVENTS | GHRCACSN">
            <h4>Finfest 2025 </h4>
            <p>GHRCACS, Nagpur, hosted an exciting Finfest 2025, bringing together finance enthusiasts, professionals,
                and students for a day of insightful discussions, competitions, and networking. The event showcased the
                latest trends in finance, offering a platform for growth and learning. A perfect blend of knowledge,
                innovation, and fun!</p>
        </div> -->
        <div class="events-inner">
            <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/unicorn-1.webp"
                alt="EVENTS | GHRCACSN">
            <h4>Creating A Unicorn </h4>
            <p>GHRCACS, Nagpur, hosted an insightful guest lecture on ‘Creating a Unicorn: Building for Scale,’
                inspiring students with strategies for rapid business growth. The session provided valuable insights
                into scaling startups, fostering innovation, and achieving entrepreneurial success in a competitive
                landscape.</p>
            <a class="cmn-button" href="/creating-unicorn">Read More</a>
        </div>
        <div class="events-inner">
            <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/raisoni-mandi.webp"
                alt="EVENTS | GHRCACSN">
            <h4>Raisoni Mandi </h4>
            <p>GHRSTU, Nagpur, successfully organised 'Raisoni Mandi', providing a dynamic platform for budding
                entrepreneurs to showcase their business acumen. The event fostered innovation, creativity, and
                real-world market experience, empowering students with essential entrepreneurial skills for a thriving
                future.</p>
        </div>
        <div class="events-inner">
            <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/gyan-manthan-1.webp"
                alt="EVENTS | GHRCACSN">
            <h4> " Gyan Manthan Management fest - Elimination round" </h4>
            <p>GHRSTU ,Nagpur's Marketing Forum brought together bright minds for an engaging session of presentations
                and group discussions. Students showcased innovative ideas, strategic insights, and collaborative
                problem-solving, fostering a deeper understanding of marketing trends and strategies. A platform for
                learning, networking, and inspiring the marketers of tomorrow!</p>
        </div>

        <div class="events-inner">
            <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/setu-2.webp" alt="GHRCCST"
                title="GHRCCST">
            <h4>Setu 2025 </h4>
            <p>GHRSTU, Nagpur organised SETU 2025, a platform bridging knowledge, innovation, and opportunities. The
                event fostered learning, collaboration, and skill-building, empowering students for a brighter future.
            </p>
        </div>

        <div class="events-inner">
            <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/science-comerce.webp"
                alt="EVENTS | GHRCACSN">
            <h4>Science & Commerce Exhibition </h4>
            <p>GHRCACS, Nagpur organised a Science & Commerce Exhibition, showcasing innovation, research, and
                entrepreneurial ideas. Students displayed creative projects, blending scientific curiosity with business
                acumen, inspiring learning beyond the classroom! </p>
        </div>

        <div class="events-inner">
            <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/budget-1.webp"
                alt="EVENTS | GHRCACSN">
            <h4>Budget Analysis competition </h4>
            <p>GHRCACS, Nagpur organised a Budget Analysis Competition, where students showcased their analytical skills
                and financial acumen. A platform to decode economic strategies, understand fiscal policies, and think
                critically about the nation's budget! </p>
        </div>

        <div class="events-inner">
            <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/shiv-jaynti.webp"
                alt="EVENTS | GHRCACSN">
            <h4>Shivaji jayanti </h4>
            <p>GHRCACS, Nagpur proudly celebrated Shivaji Jayanti on 19th February, honouring the legacy of the great
                warrior king. ⚔️👑 The event was a tribute to his valour, leadership, and vision, inspiring students
                with his timeless ideals.</p>
        </div>

        <div class="events-inner">
            <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/rotract-club-1.webp"
                alt="EVENTS | GHRCACSN">
            <h4>Rotract club </h4>
            <p>GHRCACS, Nagpur organised the Rotaract Club, fostering leadership, community service, and personal growth
                among students. A step towards making a positive impact through teamwork, innovation, and social
                responsibility! </p>
            <p>Drishtikon 2025 successfully provided students with a dynamic platform to sharpen their news analysis
                skills, conquer stage fear, and build unshakable confidence. At Raisoni Education, we take pride in
                nurturing informed, articulate, and fearless individuals who are ready to make a difference.</p>
        </div>
        <div class="events-inner">
            <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/mega-event-1.webp"
                alt="EVENTS | GHRCACSN">
            <h4>Engfinity Club' s Mega Event </h4>
            <p>GHRCACS, Nagpur organised an insightful guest lecture on the Prime Minister Internship Scheme,
                enlightening students about career opportunities, skill development, and the path to a brighter future.
                A step towards professional growth!</p>

        </div>
        <div class="events-inner">
            <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/guest-lecture-1.webp"
                alt="EVENTS | GHRCACSN">
            <h4>Guest lecture</h4>
            <p> GHRCACS, Nagpur organised an insightful guest lecture on the Prime Minister Internship Scheme,
                enlightening students about career opportunities, skill development, and the path to a brighter future.
                A step towards professional growth!.</p>

        </div>

        <div class="events-inner">
            <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/development-program-1.webp"
                alt="EVENTS | GHRCACSN">
            <h4>Student Development Program (GHRSTU), Nagpur</h4>
            <p>GHRCACS, Nagpur, hosted a transformative Student Development Programme, equipping students with the
                skills to shine brighter. </p>

        </div>
        <div class="events-inner">
            <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/vasant-1.webp"
                alt="EVENTS | GHRCACSN">
            <h4>Vasant Panchmi Saraswati Puja</h4>
            <p>GHRCACS, Nagpur, celebrated Vasant Panchami with a soulful Saraswati Puja, invoking the blessings of the
                Goddess of Wisdom. The event symbolised knowledge, creativity, and new beginnings, filling the campus
                with devotion, positivity, and cultural vibrance.</p>

        </div>
        <!-- <div class="events-inner">
            <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/kite-1.webp"
                alt="EVENTS | GHRCACSN">
            <h4>Kite Flying Festival</h4>
            <p>GHRCACS, Nagpur soared high with vibrant kites this Makar Sankranti! 🌞🪁 Celebrating the spirit of togetherness, culture, and joy, students and staff created memories under the sunlit skies. Here's to colorful traditions and boundless energy!</p>
            <a class="cmn-button" href="/kite-flying-festival">
                Read More <i class="fa fa-long-arrow-right"></i></a>
        </div>  -->
        <div class="events-inner">
            <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/news-analysis-14.avif"
                alt="EVENTS | GHRCACSN">
            <h4> News Analysis</h4>
            <p>GHRCACS, Nagpur, hosted the News Analysis Competition, fostering critical thinking and informed
                perspectives among students. Through insightful discussions and analytical skills, participants explored
                the world of news, shaping their understanding of current events. </p>
            <a class="cmn-button" href="/news-analysis">
                Read More <i class="fa fa-long-arrow-right"></i></a>
        </div>
        <div class="events-inner">
            <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/deep-milan-1.avif"
                alt="EVENTS | GHRCACSN">
            <h4> Deep Milan</h4>
            <p>GHRCACS, Nagpur, proudly organised Deep Milan, a vibrant celebration of lights, unity, and togetherness.
                Bringing together students, faculty, and traditions, this event marked a memorable evening filled with
                joy and festivity. </p>
            <a class="cmn-button" href="/deep-milan">
                Read More <i class="fa fa-long-arrow-right"></i></a>
        </div>
        <div class="events-inner">
            <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/big-boss1.avif"
                alt="EVENTS | GHRCACSN">
            <h4> Big Boss </h4>
            <p>GHRCACS, Nagpur, hosted the thrilling Big Boss event, where students took on dynamic challenges, testing
                their strategy, creativity, and leadership. An exciting experience that fostered teamwork and
                competitive spirit.</p>
            <a class="cmn-button" href="/big-boss">
                Read More <i class="fa fa-long-arrow-right"></i></a>
        </div>
        <div class="events-inner">
            <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/engfinity1.avif"
                alt="EVENTS | GHRCACSN">
            <h4> Engfinity Club' s Mega Event </h4>
            <p>Engfinity Club's Mega Event - a collaborative showcase with GH Raisoni Skill Tech University, Nagpur and
                GHRCACS, Nagpur, highlighting the latest innovations, student achievements, and technological
                advancements across the institutions.</p>
            <a class="cmn-button" href="/engfinity-club">
                Read More <i class="fa fa-long-arrow-right"></i></a>
        </div>
        <div class="events-inner">
            <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/installation-ceremony1.avif"
                alt="EVENTS | GHRCACSN">
            <h4> Installation Ceremony </h4>
            <p>GHRCACS, Nagpur, successfully conducted the installation program for the Rotaract Club and NSS. Mr Nikhil
                Chandwani, the Guest of Honour, inspired students with his insights, encouraging leadership, service,
                and community engagement.</p>
            <a class="cmn-button" href="/installation-ceremony">
                Read More <i class="fa fa-long-arrow-right"></i></a>
        </div>
        <div class="events-inner">
            <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/ganesh1.avif"
                alt="EVENTS | GHRCACSN">
            <h4> Ganesh Chaturthi</h4>
            <p>GHRCACS, Nagpur, celebrated Ganesh Chaturthi with great devotion and enthusiasm by installing a beautiful
                Ganesh idol on campus. The vibrant celebration brought students and staff together, fostering a sense of
                unity and spiritual bliss. The air was filled with joy and prayers as we welcomed Lord Ganesha, the
                remover of obstacles, with open hearts and minds.</p>
            <a class="cmn-button" href="/ganesh-chaturthi">
                Read More <i class="fa fa-long-arrow-right"></i></a>
        </div>
        <div class="events-inner">
            <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/hackathon-1.avif"
                alt="EVENTS | GHRCACSN">
            <h4> "International Hackathon for SIH - 2024"</h4>
            <p>Global Minds, Local Solutions! GHRCACS proudly hosted an International Hackathon as part of Smart India
                Hackathon 2024. Innovators from around the world came together to tackle real-world challenges with
                groundbreaking solutions. Here's to the future of smart innovation! #SmartIndiaHackathon2024
                #InnovationForIndia #GlobalHackathon #GHRCACS #TechForGood #FutureInnovators</p>
            <a class="cmn-button" href="/">
                Read More <i class="fa fa-long-arrow-right"></i></a>
        </div>
        <div class="events-inner">
            <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/mission-voting-2.avif"
                alt="EVENTS | GHRCACSN">
            <h4>Mission Voting camping</h4>
            <p>Empowering Voices, Strengthening Democracy! The 'Mission Voting Campaign' at G H Raisoni College of Arts,
                Commerce & Science, Nagpur, saw an inspiring turnout with students being encouraged to vote by actors
                Sachin Pilgaonkar, Supriya Pilgaonkar, and Swapnil Joshi. Organized by Bahujan Vichar Manch, the event
                was also graced by Dr. Vivek Kapur, Director of GHRCE Nagpur. Let's make every vote count!
                #MissionVoting #VoteForChange #RaisoniCollege #DemocracyInAction #NagpurEvents #StudentEmpowerment</p>
            <a class="cmn-button" href="mission-voting-camping" target="_blank">
                Read More <i class="fa fa-long-arrow-right"></i></a>
        </div>
        <div class="events-inner">
            <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/rakhi-competition-1.avif"
                alt="EVENTS | GHRCACSN">
            <h4>Rakhi making Competition</h4>
            <p>Crafting creativity! GHRCACS, Nagpur's Nature Nurturers Club, organised a Rakhi Making Competition, where
                students showcased their artistic skills by creating stunning rakhis. A beautiful blend of tradition and
                imagination, this event brought festive joy to life.</p>
            <a class="cmn-button" href="rakhi-making-competition" target="_blank">
                Read More <i class="fa fa-long-arrow-right"></i></a>
        </div>
        <div class="events-inner">
            <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/installation-program-1.avif"
                alt="EVENTS | GHRCACSN">
            <h4>Installation Program</h4>
            <p>GHRCACS, Nagpur, conducted the installation program of the Engfinity Club for the new batch, marking a
                fresh start for incoming students. Exciting opportunities for collaboration and innovation await as they
                embark on their journey. </p>
            <a class="cmn-button" href="installation-program" target="_blank">
                Read More <i class="fa fa-long-arrow-right"></i></a>
        </div>
        <div class="events-inner">
            <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/cynosure-1.avif"
                alt="EVENTS | GHRCACSN">
            <h4>Cynosure</h4>
            <p>Under the aegis of the Toastmasters Club, GHRCACS hosted Cynosure, a remarkable event that spotlighted
                the art of communication and leadership. Students showcased their oratory skills and creative flair,
                making it a memorable experience. A true reflection of excellence in public speaking.</p>
            <a class="cmn-button" href="cynosure" target="_blank">
                Read More <i class="fa fa-long-arrow-right"></i></a>
        </div>

        <div class="events-inner">
            <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/induction-pro.avif"
                alt="EVENTS | GHRCACSN">
            <h4>Induction program</h4>
            <p>GHRCACS, Nagpur, celebrated a vibrant induction program, welcoming new students and introducing them to a
                world of academic excellence. Welcome to the GHRCACS family! </p>
            <a class="cmn-button" href="induction-program" target="_blank">
                Read More <i class="fa fa-long-arrow-right"></i></a>
        </div>

        <div class="events-inner">
            <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/mandi-event.avif"
                alt="EVENTS | GHRCACSN">
            <h4>Raisoni Mandi</h4>
            <p>Venturing from classrooms to marketplaces! GHRCACS College's Raisoni Mandi event illuminated the path of
                practical learning, immersing students in the world of direct product selling. From market exploration
                to successful sales, every moment was a lesson in practicality and entrepreneurship.</p>
            <a class="cmn-button" href="raisoni-mandi" target="_blank">
                Read More <i class="fa fa-long-arrow-right"></i></a>
        </div>

        <div class="events-inner">
            <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/farewell-party.jpg"
                alt="EVENTS | GHRCACSN">
            <h4>Farewell Party</h4>
            <p>GHRCACS, Nagpur organised a farewell party for BBA and BCCA seniors at 7 Vachan Hall.
                It was an evening of laughter, tears, and endless memories. Big congratulations to Anushri and Aditya
                for earning the titles of Ms and Mr Farewell. Best of Luck to all the students for their future </p>
            <a class="cmn-button" href="farewell-party" target="_blank">
                Read More <i class="fa fa-long-arrow-right"></i></a>
        </div>
        <div class="events-inner">
            <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/farewell-ceremony.jpg"
                alt="EVENTS | GHRCACSN">
            <h4>Farewell Ceremony</h4>
            <p>GHRCACS Nagpur bid a heartfelt final sayonara to our BBA and BCCA seniors. The English-Hinglish themed
                farewell was a blast! Kudos to Anushri Thakur and Aditya for taking home the titles of Ms. and Mr.
                Farewell. #RaisoniEducation #AVisionBeyond #Empowerment #CommunityGrowth #ProudlyRaisonian
                #GHRCACSFarewell2024 #BBAFarewell #BCCAFarewell #FarewellFun #FarewellMemories #Nagpur</p>
            <a class="cmn-button" href="farewell-ceremony" target="_blank">
                Read More <i class="fa fa-long-arrow-right"></i></a>
        </div>
        <div class="events-inner">
            <img src="assets/images/events/turning-pages.jpg" alt="EVENTS | GHRCACSN">
            <h4>Turning the Pages of Time: The Evolutionary Chronicles</h4>
            <p>G H Raisoni College of Commerce Science & Technology celebrated 'The Engfinity Club Mega Event-2' with
                the students of BCCA, BCA, B Com (Hon.) and BSc. Data Science with great zeal on January 25, 2024.</p>
            <p>The Mega event commenced with the formal announcement of the functioning of the club followed by the
                welcoming of the Chief Guest and the dignitaries.</p>
            <p>The Chief Guest of the event was Mr. Pradyumna Arvind Deshpande, Consultant with specialization in water
                pollution. </p>
            <p>The other dignitaries who blessed the event were Director, Raisoni Business School Dr. Aarti Deshpande;
                Dean Students' Progression, Prof. Madhuri Barua, Engfinity Club Co-ordinator, Prof. Kalyani Dubey along
                with other staff members.</p>
            <p>The theme of the mega event was 'Turning the Pages of Time: The Evolutionary Chronicles'. The contest
                took place between the four teams under Engfinity Club namely Cyan, Lilac, Coral and Ivory wherein they
                presented their power point presentations and discussed the various types of evolution insightfully. The
                evaluator of the presentations, Mr. Pradyumna Arvind Deshpande, appreciated the efforts taken by the
                students and announced the names of the winners. He also shared his expertise with the students.</p>
            <p>Team Cyan was declared as the winner whereas team Ivory bagged in the runners up trophy. The host of the
                program was Ms. Anushree Thakur.</p>
            <p>The event concluded with Prize Distribution Ceremony followed by Vote of Thanks delivered by the
                President of the Engfinty Club, Ms. Riya Shrivastava. The event proved to be a grand success. </p>
        </div>
        <div class="events-inner">
            <img src="assets/images/events/engfinity-club-lgbtq.jpg" alt="EVENTS | GHRCACSN">
            <h4>Engfinity Club Mega Event</h4>
            <h6>Great Debate- The Unheard Community : LGBTQ</h6>
            <p>Engfinity CLUB at GHRCCST conducted a debate competition on February 2, 2024 on the topic “The Unheard
                Community: LGBTQ”. There were four contending teams namely Cyan Coral, Lilac and Ivory. The event
                started with the lighting of the traditional lamp and seeking the blessings of Goddess Saraswati by
                Ms.Rupali Londhe,the Judge and chief guest. Dr. Aarti Deshpande, Director, Raisoni Business School,
                Prof. Madhuri Barua, Dean Student’s Activities and Progression, Prof. Kalyani Dubey, Coordinator,
                Engfinity Club and other faculty members were prominently present. The students put forth their
                viewpoints with a lot of conviction and in depth fact finding. Team Coral was adjudged the winning team
                while Team Ivory ended up as runners up. Ms. Siya Yadav and Ms. Palak Sangani were declared the best
                speakers. Master of the ceremony was Ms. Khushi Majhetiya .The vote of thanks was proposed by the
                president of the club Ms. Riya Shrivastava. Overall, the Mega Event 3 was a grand success owing to the
                untiring zeal and efforts of Prof. Kalyani Dubey, Dr. Lalita Bisen,Prof. Anita Shrivastava and Prof.
                Manisha Banerjee. </p>
        </div>
        <div class="events-inner">
            <img src="assets/images/events/abhivyakti.jpg" alt="EVENTS | GHRCACSN">
            <h4>Press release “ABHIVYAKTI” Literary club</h4>
            <h6>Program Objectives:</h6>
            <ul class="list-item">
                <li>To aim at Vocabulary building of the students.</li>
                <li>To create Phonemic awareness/Spelling among the students.</li>
                <li>To encourage team dynamics among the students.</li>
            </ul>
            <p>‘Spell-o-voca’- an activity conducted under the banner of - “Abhivyakti”- ‘The Literary- Club’ on 5
                Feb.’24, in room number 301 on 3rd floor with the aim of enhancing the vocabulary of the learners.
            </p>
            <p>At the onset of the programme all the dignitaries and the participants were welcomed to the event. The
                dignitaries present during the activity were Prof. Madhuri Barua Dean Student’s activities and
                progression (RBS), and all English facility members teaching BCA, BBA, BCCA and B.Sc. The programme
                began with lighting of the lamp seeking blessings of Goddess Saraswati.
            </p>
            <p>The rules were displayed on the screen to acquaint the participants with the activity i.e.
                'SPELL-O-VOCA'. There were three rounds in the activity. The first round was- ‘a spell check’ round,
                where the words were dictated and participants were made to write the spellings on the given sheet. This
                was an elimination round. 15 students qualified this round.
            </p>
            <p>The second round of the activity was-'a vocabulary check' round, where in the participants were provided
                with a grid to find the synonyms of the words displayed on the screen. 8 students were declared to be
                the winner of this round.
            </p>
            <p>The final and the 3rd round was a buzzer round where in 8 students from the second activity were divided
                into 2 teams- “CHILLY CHARLOTTE” and “JOLLY JONNY” comprising 4 members each. In this activity the
                Idioms and Phrases were displayed on the screen where in the participants had to give the meaning of the
                displayed Idiom/Phrase by pressing the buzzer.
            </p>
            <p>The team 'CHILLY CHARLOTTE' came up as a winning team.
            </p>
            <p>Prof. Madhuri Barua Dean Student's activities and progression (RBS) rewarded the winners with a cash
                prize.</p>
            <p>In between various fun/literary activities were conducted for the audience.
            </p>
            <p>The activity was a successful one. All the core committee members of Literary Club have worked hard for
                the smooth conduction of the programme. The programme concluded with Prize Distribution Ceremony where
                the winning team was rewarded with a cash prize and both winners and the participants were appreciated
                with certificates. will continue to apply earlier standards with greater depth in increasingly more
                complex texts</p>
            <p> <strong>Program Outcome:</strong> The literary activity ‘Spell-O-Voca’ was a grand success and proved to
                be very
                interesting activity, wherein the participants got to enhance their vocabulary, spellings and also
                listening skills. Students learnt to use the relationships between letters and sounds, spelling
                patterns, and morphological analysis to decode written English. Students.
            </p>
        </div>
        <div class="events-inner">
            <img src="assets/images/events/press-pelease.webp" alt="EVENTS | GHRCACSN">
            <h4>Forum Installation Ceremony</h4>
            <p>The Installation ceremony of various Forums of G H Raisoni College of Commerce Science & Technology took
                place with great fervour and enthusiasm recently.</p>
            <p>Various Forums like Marketing, Finance, Human Resource Development, Entrepreneur Development, IT, Current
                News Analysis, Alumni, Cultural, Sports, RPL, Fitness, Arts and craft, Music and drama, Dance and
                happiness club etc are meant for the enhancement of the basic life and leadership skills along with
                developing confidence and team work spirit among the students of the institute. The students come up
                with polished managerial skills in due course of time by participating in different activities and
                events organised by these forums.</p>
            <p>The installation ceremony consisted of formal badge pinning and announcement of the forum restructuring.
            </p>
            <p>The Chief guest of the event, Sachin Jahagirdar, Co- Founder, Book Adda & Past - President of VMA,
                motivated all the students with his insightful words of wisdom by giving basic life mantra for a
                successful career ahead.</p>
            <p>The event was blessed with the presence of the Director Raisoni Business School Dr. Aarti Deshpande. She
                praised the dedication of the teachers and students for setting the benchmark with the superb
                performances through these clubs and forums time and again.</p>
            <p>The presidents of different forums threw light upon the overall journey so far and took oath with other
                members to keep the spirit alive further.</p>
            <p>The event was prominently attended by Faculty Incharge of Students' Activities & Progression and
                principal Dr. Jasvinder Kaur along with all HODs and other staff members.</p>
            <p>The event was witnessed and appreciated by all students in huge number. The Program was a grand success.
            </p>
        </div>

        <div class="events-inner">
            <img src="assets/images/events/awards-rotaract-club.webp" alt="EVENTS | GHRCACSN">
            <h4>Recognition &amp; awards to Rotaract Club of GHRCCST Nagpur</h4>
            <p>On 12th July, Rotaract Club of GH Raisoni College of Commerce Science &amp; Technology Nagpur won various
                awards by working hard in the academic year 2021-22 in District Rotaract Award function held at
                Bhusaval.</p>
            <p>The club was awarded the District Rotaract Citation 2021–22, Best Application of the Four Way Test. The
                club got 10th place according to the point system. Club President Meet Lakhani was awarded the Seva
                Medal for Emerging President by DRR Shri Lokesh Kansal. </p>
            <p>Meet Lakhani (Head), Khushi Khandelwal (Vice Head), Mohak Chaurasia, Aryan Dhuvavia, Ananya Saraf, Arya
                Dhakate and Siddharth Savangikar participated in the award ceremony Dr. Aarti Deshpande (Director), Dr.
                Jasvinder Kaur (Principal) and Prof. Pankaj Pethe (Club Head) of G H Raisoni College, encouraged the
                students by congratulating them.</p>

        </div>

        <div class="events-inner">
            <img src="assets/images/events/sahaja-yoga.webp" alt="EVENTS | GHRCACSN">
            <h4>SahajaYoga’s Stress Management &amp; Meditation Program for faculties of Raisoni College.</h4>
            <p>G.H Raisoni College of Commerce, Science and Technology Nagpur have organized 2 days’ workshop of
                SahajaYoga Meditation &amp; stress management for staff members of Raisoni College. This event was
                conducted on 28 th &amp; 29 th December 2021 in the college premises. The most common issue faced in
                every
                house nowadays is anxiety and depression especially during work. Sparkling some light on this most
                common problem. Our guest Adv. Mahesh Dhandekar &amp; Mrs Megha Ladvikar, are practicing from long
                time &amp; used to conduct programs in academic institutions , conference , seminars in administrative
                institutes. They came &amp; conducted program for our staff members. They explained the time and
                techniques
                of yoga that can lead to peaceful and happy life. 16 staff members enthusiastically participated in the
                activity. All staff members felt peace within, vibrations on their hand &amp; willing to do such
                practice on daily
                basis.</p>
            <p>This activity was conducted under the supervision of Prof. Pankaj Pethe. Dr.Aarti Deshpande (Director)
                &amp; Dr Jasvinder Kaur (Principal of GHRCCST) motivated and supported us to make this activity to make
                it a
                successful end. Overall the activity was very useful and beneficial for the entire academician.</p>
        </div>
        <div class="events-inner">
            <img src="assets/images/events/rpl.webp" alt="EVENTS | GHRCACSN">
            <h4>Raisoni Premier League 2020 organized at Shraddha park campus of RGI</h4>
            <p>The Sixth Season of the prestigious Raisoni Premier League 2020 was organized with great fervor in the
                Shraddha park campus of RGI. The event was organized by G H Raisoni College of Commerce Science and
                Technology from January 21, 2020 to January 25, 2020.</p>
            <p>The event was inaugurated on January 21, 2020 at the hands of Mrs. Shailja Jain, Head Coach, Iran’s
                Women’s Kabaddi Team. After various rounds of qualifying matches along with semifinal, the final match
                was played between Python Crushers and Electrifying Eels wherein the Electrifying Eels won the match and
                became the champion.</p>
            <p>The winning team was awarded with RPL Champion Trophy and a cash prize of Rs 1, 25,000 whereas the Runner
                Up team was awarded a trophy and cash Prize of Rs 50,000.</p>
            <p>The girls’ teams also fought for the RPL trophy in female category and Cool Kingfishers won the final
                match and was awarded a trophy along with a cash prize of Rs 15000.</p>
            <p>The chief guest in the valedictory function on January 25, 2020 was Shri sunil Raisoni (Chairman RGI).
                Shri. Shreyas Raisoni (Executive Director, RGI), Dr. Vivek Kapoor(Principal, GHRAET), Shri. Ashwin
                Pandey (Director, HR, RGI), Dr. Aarti Deshpande (Principal, GHRCCST) were the prominent and worthy names
                who supported ,attended and praised the event throughout. Mr. I.S. Randhava(Sports In charge RGI)
                cooperated open handedly for the smooth conduct of the event.</p>
            <p>The in charge of this event was Shri Vishal Dhabalia who, along with the students’ committee members,
                worked hard to make the event successful.</p>
        </div>
        <div class="events-inner">
            <img src="assets/images/events/gyan_manthan.webp" alt="EVENTS | GHRCACSN">
            <h4>“Gyan Manthan” - The Management Fest 2020 organized at GHRCCST, Nagpur</h4>
            <p>The most appreciated yearly event The Management Fest at G H Raisoni College of commerce Science and
                Technology was organized for the students of BBA on January 10 & 11, 2020. The college committee named
                this opulent function as “Gyan Manthan”.</p>
            <p> The basic purpose of this event was to make the students aware of their responsibilities by practicing
                many drills related to HR, Finance and Marketing domain. They develop the managerial skills this way by
                creating the product selling concept and convincing marketing strategies. </p>
            <p>On January 10, 2020 the students had presentations related to their specialized domains which were
                followed by the Networking Lunch on January 11, 2020.</p>
            <p>The judges for the presentation program were CA Sameer Khaladkar and CA Jiten Sanglani whose presence,
                evaluation and guidance truly motivated students to excel further in their career prospects. </p>
            <p>The prominent book reader Mr. Amrut Deshmukh and Mrs India 2017 Mrs Shashi Tiwari were the prominent
                guest speakers for the Networking Lunch who motivated and encouraged students through their real life
                experience.</p>
            <p>The winner teams on this occasion were awarded with shield and cash prizes.</p>
            <p>Also present in the function was Principal of the college Dr Aarti Deshpande along with all faculty
                members.</p>
            <p>Ms Madhuri Barua and Ms Kanchan Tiwari Coordinated this magnificent event efficiently and executed the
                event tremendously well.</p>
            <p>The teaching and non teaching staff along with the students worked very hard to make the program a grand
                success. </p>
        </div>
        <div class="events-inner">
            <img src="assets/images/events/mgn-fest.webp" alt="EVENTS | GHRCACSN">
            <h4>GHRCCST, Nagpur Organized “Management Fest - 2k19”</h4>
            <p>G H Raisoni College of Commerce, Science & Technology, Nagpur organized one of its most awaited
                educational event “Management Fest 2k19” on 13th 14th 15th 16th in collaboration with Impulse Technical
                for undergraduate students. The theme of the event was ' Be Different Be Unique'. The purpose behind
                organizing this grand event was to let the students explore and know the reality world of corporate by
                participating in this event and by making them meet young entrepreneurs.</p>
            <p> Advocate Anuja Kapur, Mr. Harish Iyer & Mr. Pyare Khan – Motivator & Trainer took the centre stage and
                addressed the students with their story of life. Management Fest provides a huge platform for students
                to rigorously study and keep up front their talent by participation in the various specialized fields
                like finance, human resource management, marketing and business plans. G H Raisoni College of Commerce,
                Science & Technology, Nagpur faculties felt no stone unturned to make the event a grand enlightened
                event. The participants of the event were quite excited about the event which is an ideal platform for
                them. The highlight of the event were the elimination round in which around 500 students participated
                from GH Raisoni College of Commerce, Science & Technology .The event was inaugurated at the hands of CA
                Dr. T S Rawal. Renowned personalities from the field of corporate and academics judged the event Mr.
                Gaurav Khemka, CA Renuka Borle, CA Saket Bagedia, Mr. Baldev Singh Rawat Ms Khushboo Thakur to name a
                few were the esteemed judges for the event. The event was organized in collaboration with Impulse
                Technical and knowledge partners- Vidarbha Industries, Bharat Tours, XPAND|life Maac & Sankalp. All
                winning teams were awarded trophy, certificate and cash prizes. More than 100 students and teaching and
                non teaching staff of the college participated in the networking cum valedictory session held on 16th
                February 2019 at Airport Centre Point Hotel. Event incharge was Mrs Jyoti Pillay – HoD BBA with the
                support and guidance of Officiating Principal, G H Raisoni College of Commerce, Science & Technology,
                Nagpur Dr. Aarti Deshpande. Students of the organizing committee along with non teaching staff played a
                pivotal role and worked hard to make the event happen.</p>
        </div>
        <div class="events-inner">
            <img src="assets/images/events/toas-tmaster.webp" alt="EVENTS | GHRCACSN">
            <h4>GHRCCST, Nagpur Organized A Demo Toastmasters Meet</h4>
            <p>GHRCCST, Nagpur organized a Demo of the toastmasters meet to acquaint the freshers with this signature
                activity of the college. Prior to which, Raisoni Toastmasters Club held the installation Ceremony of
                Raisoni Toastmasters General Council. Both the segment of the entire event was graced by Area Directors
                Mayuri and Shashank, TM incharge Manisha Zilpelwar, coordinator Arti Deshpande, HoD of BBA, BCCA, Jyoti
                pillay and all the faculty members. In the installation ceremony, TGC proudly marched to the centre of
                the hall, then all the council members vowed to respect the values of TM international by reciting the
                auspicious oath. The second segment of the event was demo meet where in TM Shreya was awarded the Best
                Speaker Ribbon. Also TM Surbhi was recognized as the Best Role player for her effective evaluation.
                Towards the end, the freshers were filled with a zeal to enter the world of TM. This Mega event turned
                out to be a grand Success for all.</p>
        </div>
        <div class="events-inner">
            <img src="assets/images/events/toasmaster-club.webp" alt="EVENTS | GHRCACSN">
            <h4>GHRCCST, Nagpur Conducted Raisoni Toastmaster Club Level Evaluation Competition </h4>
            <p>One of the most anticipated event that is The Raisoni Toastmaster club level Evaluation Competition was
                organized on 19th September, 2018. A total of 25 students comprising of the first, second and third year
                students participated in this competition. The evaluation was based on a test speakers speech that was
                TM Divya and her topic was “The Awkward Rainbow”. 3 Participant from each club that is The Diamond and
                The Emerald club won the positions.</p>
            <p> The Diamond club : Winner – TM Ruchi 1st runner up – TM Anushi 2nd runner up – TM Garima The Emerald
                club : Winner – TM Priya 1st runner up – TM Kashish 2nd runner up – TM Shreya The whole event was graced
                and witnessed by Divya Lakhera as the chief judge for the event also by the Co-ordinator of BBA
                department MRs Aarti Deshpande ,Head of the Department for BBA, G H Raisoni College of Commerce of
                Science & Technology, Shradha House, Kingsway, Nagpur Mrs. Jyoti Pillay Samseriya, G H Raisoni College
                of Commerce of Science & Technology, Nagpur and the Toastmaster incharge Dr. Manisha Zilpelwar, G H
                Raisoni College of Commerce of Science & Technology, Shradha House, Kingsway, Nagpur and other faculty
                members of the BBA department witnessed the meet as well. The whole event was jointly managed by both
                the clubs in E3 in G H Raisoni College of Commerce of Science & Technology, Shradha House, Kingsway,
                Nagpur. The whole event was a 2.5 hours event where 25 contestants didn't miss a chance to showcase
                their talent each participant had a different style from one another. The event was a huge success and
                both the winners from each club made it to area level. The whole contest was an absolute success for
                both the Raisoni clubs.</p>
        </div>
        <div class="events-inner">
            <img src="assets/images/events/achievers-2018.webp" alt="EVENTS | GHRCACSN">
            <h4>GHRCCST, Nagpur & Raisoni Toastmaster Club Conducted “Achievers - 2018” </h4>
            <p>Raisoni Toastmasters Club recently conducted it most unique event of the entire year i.e “ACHIEVERS” a
                special and grand meet where the speakers complete their CC10 i.e. competent communicator and thus
                become internationally certified public speakers. The event was graced by Coordinator Dr. Aarti
                Deshpande, Toastmaster Chief Mentor, Dr. Manisha Zilpelwar, Hod BBA Mrs. Jyoti Pillay, area director
                (H4) TM Mayuri and other faculty members.</p>
            <p> Moreover Mr. Manish Awasthi also supported the event with his presence. 'Achievers' is a unique event in
                itself where the proud parents of the achievers are felicitated for their constant support and parents
                felicitate their wards; the achievers of the day for their hard work and dedication throughout. The
                final level is a 8-10 minutes speech with an objective to inspire the audience and imbibe all the other
                objectives learnt during the entire journey. The achievers of the day were, TM Pawan CC-10, TM Surbhi
                CC-10, TM Priya CC-10 & TM Shreya CC-10. Apart from Public Speakers, Toastmasters also creates Leaders
                and certifies them with its CL (Competent Leader) certificate. CC Holders TM Pranay, TM Kashish, TM
                Ruchi & TM Surbhi. The entire event was a huge success which ended up by motivating the junior
                toastmasters to be a good speaker and leader as well.</p>
        </div>
        <div class="events-inner">
            <img src="assets/images/events/farewell.webp" alt="EVENTS | GHRCACSN">
            <h4>G H Raisoni College of Commerce Science & Technology, Nagpur Organized A Gala Farewell </h4>
            <p>G H Raisoni College of Commerce Science & Technology, Nagpur organized a Gala Farewell for the final year
                students of BBA & BCCA, G H Raisoni College of Commerce Science & Technology, Nagpur at Naivedhyam
                Estoria wherein the juniors bid adieu to their seniors with great enthusiasm and off course nostalgia.
                Students were dressed up in lovely attires and followed the theme 'GRAND BALL'.</p>
            <p> Students presented very entertaining group dances and exciting games, various titles and token of love
                were given to the seniors. Different tags were awarded to the students, tag of Miss Well Dressed & Mr.
                Well Dressed were won by Miss Ruchi Maloo & Mr. Maaz Khan. Finally Miss Ekta Baheti of BBA Final Year
                was crowned with the title of 'Miss Farewell' and Mr. Ushabh Jain of BCCA was awarded the title of 'Mr.
                Farewell'. Students were set rushing on foot tapping songs as the floor was set on fire with DJ and
                music. A large number of students, along with officiating Principal of G H Raisoni College of Commerce
                Science & Technology, Nagpur, Dr. Aarti Deshpande teaching and non teaching staff of the college
                participated in the event. Mrs. Jyoti Pillay and Dr Jasvinder Kaur worked hard for the success of the
                program.</p>
        </div>
        <div class="events-inner">
            <img src="assets/images/events/icebreaker.webp" alt="EVENTS | GHRCACSN">
            <h4>A Workshop on “How to Ace Your Icebreaker” Conducted at GHRCCST, Nagpur</h4>
            <p>A workshop on “How to ace your icebreaker” was conducted on 28th July 2018 in Vivekanand Hall by TM
                Ruchi. The basic idea behind conducting this workshop was to make the freshers familiar with the framing
                and delivery of icebreaker speech. TM Ruchi explained the students about the basics of icebreaker
                through a PPT presentation. The objectives of icebreaker, organization of speech, insights for
                icebreaker, various ways to choose topics for icebreaker, etc.. and many more points were explained.
                Later on, students were given the chance to ask questions regarding the workshop. Also TM Aarti
                Deshpande gave her feedback regarding the conduct of workshop.</p>
        </div>
        <div class="events-inner">
            <img src="assets/images/events/clash-clans.webp" alt="EVENTS | GHRCACSN">
            <h4>GHRCCST, Nagpur Organized “Clash of Clans” Under Toast Fest - 2k19</h4>
            <p>The biggest event of Raisoni toastmasters club “Toast Fest” was conducted on 30th and 31st January, 2019.
                The audacious young talents of Raisoni Toastmasters Club made the event a huge success. This is the
                event which decides the best club among the two diligent clubs of Raisoni Toastmasters i.e. Emerald and
                Diamond. Day one was organized by the Emerald Club with a grand opening ceremony and theme reveal in
                bollywood style followed by a euphonious music, band and three events lined for the day (Netflix,
                Extricate, Spin a Yarn) .</p>
            <p> Second day was organized by Diamond Club with a carnival bash with two events lined (War of Views and
                Street play) and closing ceremony with a carnival parade. Toast Fest is not just another college fest
                rather it helps to ameliorate competitive spirit, planning, futuristic thinking and many such skills in
                students. There were many criteria to judge the best club be it discipline, decoration, dedication,
                total number of theme meets, total number of ice breakers, total number of new participants and winning
                points in the event. It is not just the two days but the annual presentation, preparation and commitment
                of club towards toastmasters which is taken into consideration. And this year the best club having the
                highest points was the Emerald Club. Emerald club bagged the best club award for the third time in a
                row. The dedication to furbish Toast Fest of academic year 2019-20 can be seen as the evaluation for
                upcoming best club has begun and students are ready to iridescent again. </p>
        </div>
        <div class="events-inner">
            <h4>Club Officer Training Programme Conducted at GHRCCST, Nagpur</h4>
            <p>The Club Officer Training Programme was conducted on July 15 2018 8:30am, At E3, Raisoni Toastmaster's
                Club, Shraddha House, Kingsway , Nagpur. The motive behind COTP ie. Club Officers Training Programme was
                to train the Club officers with respect to various norms of Toastmasters International. All the club
                officers of various clubs of Nagpur attended the training programme. The training programme was
                conducted by divisional director Division H Toastmaster Subhangi Pandey. Also the presence of Area
                director area H4 Toastmaster Mayuri and area H5 Toastmaster Shashank was noted. The training programme
                consisted of various work culture, roles and responsibilities of the club officers. DIAMOND Ruchi Maloo
                - VP member Varad Kulkarni - VP OR Surbhi Agrawal- Treasurer Hussain- SAA EMERALD Tanushree – SAA
                Shubham Toshniwal - VP PR Shreya Jain – Treasurer Moreover, Toastmaster Shashank (Area Director H5)
                conducted the judges training programme (JTP) for the upcoming contest of Humorous and Evaluation. It
                Consisted of Various insights of Judginh criteria for the contest </p>
        </div>
        <div class="events-inner">
            <img src="assets/images/events/christmas.webp" alt="EVENTS | GHRCACSN">
            <h4>Rotaract Club of GHRCCST, Nagpur Celebrated Christmas with Street Children</h4>
            <p>Rotaract Club of G H Raisoni College of Commerce, Science & Technology, Nagpur celebrated Christmas with
                street children & donated cloths to needy people near Maharajbag Garden Nagpur. 7 Rotaract club members
                along with one faculty member Prof. Pankaj Pethe (In charge Rotaract club) celebrated this evening with
                22 children. We had wonderful time in singing Christmas songs, followed by refreshment. We distributed
                cloths to all needy people those are living on footpath. Children presented their poems & their
                educational abilities. Mrs. Aarti Deshpande, Co-ordinator, G H Raisoni College of Commerce, Science &
                Technology, Nagpur motivated & supported us to make this event fabulous. The motive of this Rotaract
                visit was to interact with small children for sharing happiness.</p>
        </div>
        <div class="events-inner">
            <img src="assets/images/events/good-businessplan.webp" alt="EVENTS | GHRCACSN">
            <h4>GHRCCST, Nagpur Organized A Guest Lecture on “How to Prepare A Good Business Plan”</h4>
            <p>I.I.I ( INDUSTRY INSTITUTE INTERACTION ) cell of G H Raisoni College of Commerce, Science & Technology,
                Nagpur has organized a Guest Lecture on the topic “ How to Prepare A Good Business Plan Presentation”
                for BBA – I Year ,BBA –II year, BBA–III year on 5th December 2017 . The Guest Lecture was delivered by –
                Mr. Mukesh Ashar, Cofounder of Lemon School of Entrepreneurship, Nagpur. He discussed in detail how to
                conceive an innovative idea and converting it into a good business plan. He also explained the procedure
                and content of a good business plan. He gave guidelines for the preparation of a business plan
                presentation and how to present it. The session was interactive and useful for the students. Coordinator
                of G H Raisoni College of Commerce , Science & Technology, Nagpur, Mrs. Aarti Deshpande, and HoD BBA
                department, Mrs. Jyoti Samseriya , CA Manish Shah and other faculty members were attended this guest
                lecture. Dr. Jasvinder Kaur III cell In charge along with the Gaurav Rajpal (President III), Ushabh Jain
                (vice president III) and students member of III cell had taken the initiative for the programme.</p>
        </div>
        <div class="events-inner">
            <img src="assets/images/events/jadhao-industries.webp" alt="EVENTS | GHRCACSN">
            <h4>GHRCCST, Nagpur Conducted Industrial Tour to Jadhao Industries</h4>
            <p>G H Raisoni College of Commerce, Science & Technology, Nagpur BBA Department conducted 2 days Industrial
                tour for BBA II year students to Jadhao Industries on 7th & 8th December - 2017. There were 75 students
                in two days of visit with three faculty member Dr. Jasvinder Kaur, Prof. Pankaj Pethe, Mr. Islam
                Siddiqui. On 8th December we visited Jadhao Gears (Ginning division); students visited this industry
                where they learnt assembly of ginning machine. They also observed the tie ups, dealers' details,
                production line up, cost cutting methods and supply chain management. The motive of this industrial
                visit was to impart knowledge of commercial activities as well as exhilarate students.</p>
        </div>
        <div class="events-inner">
            <img src="assets/images/events/coffee-cupmeet.webp" alt="EVENTS | GHRCACSN">
            <h4>Coffee Cup Meet Organized at GHRCCST, Nagpur</h4>
            <p>Coffee cup meeting –A meeting organized with the alumni for BCCA students. The session was delivered by
                Mr. Harshad Sarvaiya the alumni of the BCCA department. He is a government employee working as a Junior
                Statistical Officer in Indian Bureau Of Mines Nagpur. The alumni shared his experience with the
                students. Mr. Harshad interacted with the students and motivated them by sharing his life experiences.
                He told the students how to study and prepare for the exams. He also enlightened students how they
                should deal with interviews and other competitive exams. Altogether it was a very informative and useful
                session for all the students.</p>
        </div>
    </div>
</section>